import { render, staticRenderFns } from "./OverlayConfigPanel.vue?vue&type=template&id=5fae04f8&scoped=true&"
import script from "./OverlayConfigPanel.vue?vue&type=script&lang=js&"
export * from "./OverlayConfigPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fae04f8",
  null
  
)

export default component.exports